import { Component, Input } from '@angular/core';
import { TranslationService } from '../../translations';

@Component({
    selector: 'preview-card',
    template: `
        <div class="lightGreyShadow" [ngClass]="cssClass">
            <div class="contentContainer layoutCenteredColumn">
                <div class="purpleOverlay"></div>
                <img [src]="imageSrc" class="previewCardContent" />
                <ng-content nonHoverContent></ng-content>
                <div class="color-neutral-50 forceMiddle contentFadeIn">
                    <ng-content
                        hoverContent
                        select="[hoverContent]"
                    ></ng-content>
                </div>
            </div>
            <div class="purpleLine"></div>
            <div
                class="darkPurpleText largeText verticalAlign_midSizeContainer boldText"
                style="margin-left:20px;"
            >
                {{ TR.key(textKey) }}
            </div>
        </div>
    `,
    standalone: false
})
export class PreviewCardComponent {
    @Input()
    textKey: string;
    @Input()
    imageSrc: string;
    @Input()
    cssClass?: string;

    constructor(public TR: TranslationService) {}
}
